import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faRobot, faCircleExclamation, faUserGear } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/contract.jpg';

function ContractDraftingScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Contract Drafting & Management'>
          <Breadcrumb parent="Services" screen='Contract Drafting & Management'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Contract Drafting & Management"
          description="Simplify your contract processes with PocketLPO’s Contract Drafting & Management services. From creation to execution, we ensure your contracts are clear, enforceable, and aligned with your business objectives."
          services={[
            "Drafting of contracts including NDAs, employment agreements, and vendor contracts.",
            "Comprehensive contract reviews to identify risks and ambiguities.",
            "AI-powered contract lifecycle management for efficiency."
          ]}
          benefits={[
            { title: "Risk Mitigation", description: "Avoid costly disputes with expertly drafted contracts.", icon: faCircleExclamation },
            { title: "Efficiency", description: "Leverage AI tools for streamlined contract management.", icon: faRobot },
            { title: "Expert Support", description: "Access legal professionals skilled in diverse industries.", icon: faUserGear }
          ]}
          image={image}
        />
    </>
  );
}

export default ContractDraftingScreen;
